import { sendRequest } from "../request";
const BASE_URL = '/api/allForms';

export function create(clientID, data) {
    return sendRequest(`${BASE_URL}/${clientID}`, "POST", data, "Unable to create form(s)");
}

export function getIntakeForms() {
    return sendRequest(`${BASE_URL}`)
}

export function getClientIntakeForms(clientID) {
    return sendRequest(`${BASE_URL}/client/${clientID}`)
}

export function getIntakeForm(formID) {
    return sendRequest(`${BASE_URL}/${formID}`)
}

export function getProjectNumbers() {
    return sendRequest(`${BASE_URL}/getProjectNumbers`, "GET", null, "Unable to get project numbers")
}

export function updateForm(formID, data) {
    return sendRequest(`${BASE_URL}/updateForms/${formID}`, "PUT", data, "Unable to update form");
}

export function manuallyCompleteForm(formID, status) {
    return sendRequest(`${BASE_URL}/manuallyCompleteForm/${formID}`, "PUT", { status }, "Unable to update form status");
}

export function deleteForm(formID) {
    return sendRequest(`${BASE_URL}/deleteForms/${formID}`, "DELETE", null, "Unable to delete form");
}

export function generateProject(formID, data) {
    return sendRequest(`${BASE_URL}/generateProject/${formID}`, "POST", data, "Unable to generate project");
}

export function updateNotes(data) {
    return sendRequest(`${BASE_URL}/${data.formID}/updateNotes`, "POST", data, "Unable to update notes")
}

export function findForms(user, searchQuery) {
    return sendRequest(`${BASE_URL}/findForms/${user._id}/${searchQuery}`)
}